import { formatPhoneNumberNational } from 'shared/lib'
import { type InboxesStore } from 'entities/Inbox'
import {
  type ICallTransferFailedReason,
  type IResponseCallTransferStarted,
} from 'entities/Call/api/types'

export const getTransferTargetName = (
  payload: IResponseCallTransferStarted,
  inboxesStore: InboxesStore
): string => {
  if (payload.target_inbox_id !== null) {
    const inbox = inboxesStore.getItem(payload.target_inbox_id)
    return inbox?.name ?? 'inbox'
  }

  if (payload.target_external_number !== null) {
    return formatPhoneNumberNational(payload.target_external_number)
  }

  return 'target'
}

const failureCopy: Record<ICallTransferFailedReason, string> = {
  'no-answer': 'No agent answered.',
  busy: 'Target line is busy.',
  failed: 'Transfer failed.',
  canceled: 'Transfer was canceled.',
}

const fallbackFailureCopy = 'Transfer failed.'

const isKnownReason = (reason: string): reason is ICallTransferFailedReason => reason in failureCopy

export const getTransferFailureDescription = (reason: string): string => {
  if (isKnownReason(reason)) {
    return failureCopy[reason]
  }

  return fallbackFailureCopy
}
